module.exports = __webpack_public_path__ + "static/media/all.f6d77893.png";